import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  "no-gutters": "",
  style: {"width":"75vw"},
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_AccountableAccountBalanceDetail = _resolveComponent("AccountableAccountBalanceDetail")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, { class: "default_card_wm elevation-0 px-4 py-3 mb-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          class: "d-flex align-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "9",
              class: "d-flex align-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_icon, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showData = !_ctx.showData)),
                  icon: _ctx.showData ? '$fa-chevron-up' : '$fa-chevron-down'
                }, null, 8, ["icon"]),
                _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "ml-4" }, "Informations bénéficiaires", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "3",
              class: "d-flex justify-end"
            }, {
              default: _withCtx(() => [
                (_ctx.showData)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      rounded: "",
                      size: "small",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addManualRow()))
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" Ajouter une ligne ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex",
                  style: {"height":"432px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      size: "28",
                      class: "mx-auto",
                      color: "primary"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_ctx.isIncomingOutgoingPaymentAccountingType)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "ml-4"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" En comptabilité de trésorerie, il n'y a pas de récupération des montants depuis la comptabilité, la DAS2 est à remplir manuellement. ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_row, {
                key: 2,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "ml-4"
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Les racines de comptes utilisées par l'assistant sont les suivantes : 604, 622 et 651. ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })),
        (!_ctx.items || !_ctx.items.length)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 3,
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "ml-4 mt-4"
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createElementVNode("b", null, "Aucune donnée trouvée.", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showData)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                "no-gutters": "",
                class: "px-4 py-4",
                key: index
              }, [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "d-flex align-center py-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_icon, {
                          onClick: ($event: any) => (item.toggleExpand()),
                          size: "small",
                          icon: item.isExpanded ? '$fa-chevron-up' : '$fa-chevron-down'
                        }, null, 8, ["onClick", "icon"]),
                        _createElementVNode("b", null, _toDisplayString(item.thirdPartyCompanyName), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "px-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: item.debit,
                          "onUpdate:modelValue": ($event: any) => ((item.debit) = $event),
                          label: "Montant TTC",
                          outlined: "",
                          "hide-details": "auto",
                          density: "compact",
                          "append-inner-icon": item.id && '$oss-eye',
                          "onClick:appendInner": ($event: any) => (_ctx.openDetailDialog(item)),
                          rules: [(value) => _ctx.noDecimalAndMinRule(value)]
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "append-inner-icon", "onClick:appendInner", "rules"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "px-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          modelValue: item.type,
                          "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                          label: "Nature",
                          items: _ctx.itemTypes,
                          "hide-details": "",
                          outlined: "",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "px-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: item.profession,
                          "onUpdate:modelValue": ($event: any) => ((item.profession) = $event),
                          label: "Profession",
                          outlined: "",
                          "hide-details": "auto",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "d-flex align-center justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_switch, {
                          modelValue: item.toAdd,
                          "onUpdate:modelValue": ($event: any) => ((item.toAdd) = $event),
                          onClick: ($event: any) => (item.toggleAdd())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]),
                        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "ml-3" }, "A déclarer", -1))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                (item.isExpanded)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "px-1 py-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "px-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: item.naturalPerson,
                                "onUpdate:modelValue": ($event: any) => ((item.naturalPerson) = $event),
                                label: "Personne physique",
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "px-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: item.thirdPartyCompanyName,
                                "onUpdate:modelValue": ($event: any) => ((item.thirdPartyCompanyName) = $event),
                                label: item.naturalPerson ? 'Nom Prénom' : 'Raison sociale',
                                outlined: "",
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "px-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: item.siret,
                                "onUpdate:modelValue": ($event: any) => ((item.siret) = $event),
                                label: "SIRET",
                                onInput: ($event: any) => (item.siret = _ctx.onInputSetTruncatedSiret(item.siret)),
                                outlined: "",
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "px-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: item.legalForm,
                                "onUpdate:modelValue": ($event: any) => ((item.legalForm) = $event),
                                label: "Forme juridique",
                                outlined: "",
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "px-1 py-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "1",
                            class: "px-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: item.number,
                                "onUpdate:modelValue": ($event: any) => ((item.number) = $event),
                                label: "Numéro",
                                outlined: "",
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "1",
                            class: "px-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: item.btq,
                                "onUpdate:modelValue": ($event: any) => ((item.btq) = $event),
                                label: "BTQ",
                                outlined: "",
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "px-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: item.street,
                                "onUpdate:modelValue": ($event: any) => ((item.street) = $event),
                                label: "Voie",
                                outlined: "",
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "px-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: item.city,
                                "onUpdate:modelValue": [($event: any) => ((item.city) = $event), ($event: any) => (_ctx.onPostalCodeOrCityChange(item))],
                                label: "Commune",
                                outlined: "",
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "1",
                            class: "px-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: item.postalCode,
                                "onUpdate:modelValue": [($event: any) => ((item.postalCode) = $event), ($event: any) => (_ctx.onPostalCodeOrCityChange(item))],
                                label: "Code postal",
                                outlined: "",
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "px-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: item.inseeCode,
                                "onUpdate:modelValue": ($event: any) => ((item.inseeCode) = $event),
                                label: "Code Insee commune",
                                outlined: "",
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "px-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: item.postOfficeDistributor,
                                "onUpdate:modelValue": ($event: any) => ((item.postOfficeDistributor) = $event),
                                label: "Bureau distributeur",
                                outlined: "",
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ], 64))
                  : _createCommentVNode("", true),
                (index < _ctx.items.length - 1)
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_divider)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      title: _ctx.selectedItem && `Détail - ${_ctx.selectedItem.thirdPartyCompanyName}`,
      modelValue: _ctx.showBalanceDetailDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showBalanceDetailDialog) = $event)),
      onValid: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeDetailDialog())),
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeDetailDialog())),
      validTitle: "Fermer"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_AccountableAccountBalanceDetail, {
            companyId: _ctx.companyId,
            accountableAccountInfo: _ctx.accountableAccountInfo,
            startDate: _ctx.startDate,
            endDate: _ctx.endDate
          }, null, 8, ["companyId", "accountableAccountInfo", "startDate", "endDate"])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}